// ============================================================================
// SITE DETAILS SECTION COMPONENT
// ============================================================================

import React, { useEffect } from "react";
import { Box, Typography, Autocomplete, TextField, Grid } from "@mui/material";
import { MapPinIcon, PencilIcon } from "@heroicons/react/24/outline";
import CustumCard from "../../../../components/common/CustumCard";
import DetailRow from "../../../../form/DetailRow";
import { useAppDispatch, useAppSelector } from "../../../../store";
import { fetchSites, selectSites } from "../../../site/siteSlice";

interface SiteDetailsSectionProps {
  siteData: any;
  sites: any[] | null;
  selectedCustomerId: string;
  selectedSiteId: string;
  siteSearch: string;
  isEditingSite: boolean;
  editMode: boolean;
  onSiteSelection: (site: any) => void;
  onSiteSearchChange: (value: string) => void;
  onEditSite: () => void;
}

const SiteDetailsSection: React.FC<SiteDetailsSectionProps> = ({
  siteData,
  sites,
  selectedCustomerId,
  selectedSiteId,
  siteSearch,
  isEditingSite,
  editMode,
  onSiteSelection,
  onSiteSearchChange,
  onEditSite,
}) => {
  const dispatch = useAppDispatch();
  const filterSites = useAppSelector(selectSites);
  // const filteredSites = React.useMemo(() => {
  //   if (!selectedCustomerId) return sites || [];
  //   return (sites || []).filter((site) => site.customer?.customerId === selectedCustomerId);
  // }, [sites, selectedCustomerId]);

  useEffect(() => {
    console.log("sites form sitedetailModal:", sites);
    console.log("selectedCustomerId form sitedetailModal:", selectedCustomerId);
    console.log("selectedSiteId form sitedetailModal:", selectedSiteId);
    console.log("filterSites form sitedetailModal:", filterSites);
  }, [sites, selectedCustomerId, selectedSiteId, filterSites]);

  // useEffect(() => {
  //   if (sites?.length === 0 && (selectedCustomerId && !selectedSiteId)) {
  //     // dispatch(fet)
  //     dispatch(fetchSites({ customerId: selectedCustomerId }))
  // }})

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CustumCard>
        {/* Header: Logo + Title */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 3 }}>
          <MapPinIcon color="primary" width={22} />
          <Typography variant="h6" sx={{ fontWeight: 800, fontSize: 18 }}>
            Sites Information
          </Typography>
        </Box>

        {/* Site Selection / Display */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3, flex: 1 }}>
          {isEditingSite || !siteData ? (
            <Autocomplete
              options={sites || []}
              getOptionLabel={(option) =>
                option?.name
                  ? `${option.name}${
                      option.address ? ` (${option.address})` : ""
                    }`
                  : ""
              }
              value={sites?.find((c) => c.id === selectedSiteId) || null}
              onChange={(_, value) => onSiteSelection(value)}
              inputValue={siteSearch}
              onInputChange={(_, value) => onSiteSearchChange(value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Site"
                  variant="outlined"
                  fullWidth
                />
              )}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              sx={{ mb: 2 }}
            />
          ) : (
            <Box
              sx={{ display: "flex", flexDirection: "column", gap: 3, flex: 1 }}
            >
              {/* First Row: Site Name (50%) + Contact Person (25%) + Contact Phone (25%) */}
              <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                {/* Site Name - 50% width */}
                <Box sx={{ flex: "0 0 calc(50% - 8px)", minWidth: "200px" }}>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontSize: 12,
                      fontWeight: 700,
                      color: "text.secondary",
                    }}
                  >
                    Site Name
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ fontSize: 16, fontWeight: 400 }}
                  >
                    {siteData.name || "-"}
                  </Typography>
                </Box>

                {/* Contact Person - 25% width */}
                <Box sx={{ flex: "0 0 calc(25% - 8px)", minWidth: "150px" }}>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontSize: 12,
                      fontWeight: 700,
                      color: "text.secondary",
                    }}
                  >
                    Contact Person
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ fontSize: 16, fontWeight: 400 }}
                  >
                    {siteData.contactPerson || "-"}
                  </Typography>
                </Box>

                {/* Contact Phone - 25% width */}
                <Box sx={{ flex: "0 0 calc(25% - 8px)", minWidth: "150px" }}>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontSize: 12,
                      fontWeight: 700,
                      color: "text.secondary",
                    }}
                  >
                    Contact Phone
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ fontSize: 16, fontWeight: 400 }}
                  >
                    {siteData.contactPhone || "-"}
                  </Typography>
                </Box>
              </Box>

              {/* Second Row: Address - 100% width */}
              <Box sx={{ width: "100%" }}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontSize: 12,
                    fontWeight: 700,
                    color: "text.secondary",
                  }}
                >
                  Address
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontSize: 16, fontWeight: 400 }}
                >
                  {`${siteData.address}, ${siteData.city}, ${siteData.state}` ||
                    "-"}
                </Typography>
              </Box>
            </Box>
          )}
        </Box>
      </CustumCard>
    </Box>
  );
};

export default SiteDetailsSection;
